import axios from "axios";
import { DEFAULT_GET_TREATMENTS_ROUTE, GENERIC_TREATMENTS_ERROR, } from "./constants";
import generateControlTreatment from "./generateControlTreatment";
import isClientSide from "./isClientSide";
const getClientSideSplitTreatments = async (treatmentNames, splitKey, { attributes, apiPathString = DEFAULT_GET_TREATMENTS_ROUTE } = {}) => {
    try {
        if (!isClientSide()) {
            throw new Error("Cannot use getClientSideSplitTreatments server-side. Use getServerSideSplitTreatments instead.");
        }
        const { data } = await axios.get(apiPathString, {
            params: {
                attributes,
                splitKey: await splitKey,
                treatmentNames: String(treatmentNames),
            },
        });
        return data;
    }
    catch (e) {
        console.error(new Error(axios.isAxiosError(e)
            ? e.response
                ?.data?.error || GENERIC_TREATMENTS_ERROR
            : (typeof e === "object" && e.message) || GENERIC_TREATMENTS_ERROR));
        return generateControlTreatment(treatmentNames);
    }
};
export default getClientSideSplitTreatments;
